import React from 'react'
import styles from './styles.css'
import { Form, Field } from 'simple-react-form'
import Text from 'orionsoft-parts/lib/components/fields/Text'
import Textarea from 'orionsoft-parts/lib/components/fields/Textarea'
import PropTypes from 'prop-types'
import autobind from 'autobind-decorator'
import withMutation from 'react-apollo-decorators/lib/withMutation'
import gql from 'graphql-tag'
import withMessage from 'orionsoft-parts/lib/decorators/withMessage'
import Button from 'orionsoft-parts/lib/components/Button'
import Tags from 'App/components/fields/Tags'
import TiInfoOutline from 'react-icons/lib/ti/info-outline'
import isAdmin from 'App/Decorators/isAdmin'

@isAdmin
@withMutation(gql`
  mutation updateDocumentInformation(
    $documentId: ID
    $name: String
    $description: String
    $tags: [String]
    $organizationId: ID
  ) {
    updateDocumentInformation(
      documentId: $documentId
      name: $name
      description: $description
      tags: $tags
      organizationId: $organizationId
    ) {
      _id
      name
      description
      tags
    }
  }
`)
@withMutation(gql`
  mutation updateDocumentTags(
    $documentId: ID
    $description: String
    $tags: [String]
    $organizationId: ID
  ) {
    updateDocumentTags(
      documentId: $documentId
      description: $description
      tags: $tags
      organizationId: $organizationId
    ) {
      _id
      name
    }
  }
`)
@withMessage
export default class UpdateInformation extends React.Component {
  static propTypes = {
    showMessage: PropTypes.func,
    document: PropTypes.object,
    updateDocumentInformation: PropTypes.func,
    updateDocumentTags: PropTypes.func,
    organization: PropTypes.object,
    admin: PropTypes.string,
    url: PropTypes.bool,
    params: PropTypes.object
  }

  static fragment = gql`
    fragment documentUpdateInformation on Document {
      name
      description
      fromTemplate
    }
  `

  state = {}

  @autobind
  async save({ name, description, tags }) {
    this.setState({ loading: true })
    try {
      await this.props.updateDocumentInformation(
        {
          documentId: this.props.document._id,
          name,
          description,
          tags,
          organizationId: this.props.organization._id
        },
        {
          refetchQueries: ['getDocument']
        }
      )
      this.props.showMessage('Success')
    } catch (error) {
      console.log('Error:', error)
      this.props.showMessage(error.message, { level: 'error' })
    }
    this.setState({ loading: false })
  }

  state = {}

  @autobind
  async saveTags({ description, tags }) {
    this.setState({ loading: true })
    try {
      await this.props.updateDocumentTags(
        {
          documentId: this.props.document._id,
          description,
          tags,
          organizationId: this.props.organization._id
        },
        {
          refetchQueries: ['getDocument']
        }
      )
      this.props.showMessage('Success')
    } catch (error) {
      console.log('Error:', error)
      this.props.showMessage(error.message, { level: 'error' })
    }
    this.setState({ loading: false })
  }

  buttonsAppear() {
    if (
      (!this.props.url && this.props.document.documentOwner) ||
      (this.props.organization && this.props.organization.myRole === 'owner')
    ) {
      return true
    }
    return false
  }

  renderFirstForm() {
    return (
      <div className={styles.container}>
        <Form
          ref={form => {
            this.form = form
          }}
          state={this.props.document}
          onSubmit={this.save}
        >
          <div className="section">
            <div className="header">
              <div className="row">
                <div className="col-xs-12 col-sm-4">
                  <h3 className={styles.title}>Información del documento</h3>
                </div>
                <div className="col-xs-12 col-sm-8 end-md">
                  <div className={styles.icon}>
                    <TiInfoOutline size={20} />
                  </div>
                </div>
              </div>
            </div>
            <div className="content">
              <div className="label">Nombre</div>
              <Field fieldName="name" placeholder="Nombre" type={Text} />
              <br />
              <div className="label">Tags (opcional)</div>
              <div className=""><small>Escribe el texto que quieres usar como etiqueta de este documento y luego presiona <i>Enter</i> para activarla.</small></div>
              <Field fieldName="tags" type={Tags} />
              <br />
              <div className="label">Descripción (opcional)</div>
              <Field
                fieldName="description"
                placeholder="Descripción"
                type={Textarea}
              />
              <br />
              {this.buttonsAppear() ? (
                <Button
                  primary
                  loading={this.state.loading}
                  onClick={() => this.form.submit()}
                >
                  Guardar
                </Button>
              ) : null}
            </div>
          </div>
        </Form>
      </div>
    )
  }

  renderSecondForm() {
    if (
      (!this.props.document.documentOwner &&
        !this.props.organization._id &&
        !this.props.url) ||
      (!this.props.document.documentOwner &&
        this.props.organization._id &&
        this.props.organization.myRole[0] === 'member')
    ) {
      return null
    }
    return (
      <div className={styles.container}>
        <Form
          ref={form => {
            this.form = form
          }}
          state={this.props.document}
          onSubmit={this.saveTags}
        >
          <div className="section">
            <div className="header">
              <div className="row">
                <div className="col-xs-12 col-sm-4">
                  <h3 className={styles.title}>Información del documento</h3>
                </div>
                <div className="col-xs-12 col-sm-8 end-md">
                  <div className={styles.icon}>
                    <TiInfoOutline size={20} />
                  </div>
                </div>
              </div>
            </div>
            <div className="content">
              <div className="label">Tags (opcional)</div>
              <div className=""><small>Escribe el texto que quieres usar como etiqueta de este documento y luego presiona <i>Enter</i> para activarla.</small></div>
              <Field fieldName="tags" type={Tags} />
              <br />
              <div className="label">Descripción (opcional)</div>
              <Field
                fieldName="description"
                placeholder="Descripción"
                type={Textarea}
              />
              <br />
              {this.buttonsAppear() ? (
                <Button
                  primary
                  loading={this.state.loading}
                  onClick={() => this.form.submit()}
                >
                  Guardar
                </Button>
              ) : null}
            </div>
          </div>
        </Form>
      </div>
    )
  }

  render() {
    if (!this.props.document.signatureRequested) {
      return <div className={styles.container}>{this.renderFirstForm()}</div>
    } else {
      return <div className={styles.container}>{this.renderSecondForm()}</div>
    }
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Documents/Document/UpdateInformation/index.js